





























import { Component } from 'vue-property-decorator';
import { ReportsModule } from '@/store/Reporting/ReportsModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import BalancesReportDialog from '@/components/Reporting/Reports/BalancesReportDialog.vue';
import AllAccountsReportDialog from '@/components/Reporting/Reports/AllAccountsReportDialog.vue';
import EndOfDayAccountStateReportDialog from '@/components/Reporting/Reports/EodAccountStateReportDialog.vue';

@Component({ name: 'Reports', components: { Alert, BalancesReportDialog, EndOfDayAccountStateReportDialog, AllAccountsReportDialog }, metaInfo: { title: 'Reports' } })
export default class extends SaascadaVue {

    headers = [
        { text: this.$t('pageText.reports.fields.reportType'), sortable: false, width: '60%' },
        { text: this.$t('pageText.reports.fields.actions'), sortable: false, width: '40%' }
    ];
    reportsPage = 1;

    get reports() {
        // Hardcoded for now until we can get reports from the API
        return [
            { name: "End of day balances (All Accounts)", type: "endOfDayBalances" },
            { name: "End of day account state (All FTD Accounts)", type: "endOfDayAccountStateFTD" },
            { name: "Transactions (All Accounts)", type: "allAccountTransactions" }
        ];
    }

    get totalReportsPages() {
        // Hardcoded for now until we can get reports from the API
        return 1;
    }

    get loading() {
        return false;
    }

    get pageSize() {
        return ReportsModule.pageSize;
    }

}
